import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import PageLoader from './components/PageLoader';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BrandsStrip from './components/BrandsStrip';
import AboutSection from './components/AboutSection';
import MarketplaceSection from './components/MarketplaceSection';
import YouTubeSection from './components/YouTubeSection';
import BlogSection from './components/BlogSection';
import FaqSection from './components/FaqSection';
import ContactWidget from './components/ContactWidget';
import ChatBot from './components/ChatBot';
import PopupForm from './components/PopupForm';
import Footer from './components/Footer';
import BlogListPage from './pages/BlogListPage';
import BlogDetailPage from './pages/BlogDetailPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CareersPage from './pages/CareersPage';
import AdminDashboard from './pages/AdminDashboard';

// Service pages
import AmazonPage from './pages/services/AmazonPage';
import ShopifyPage from './pages/services/ShopifyPage';
import WalmartPage from './pages/services/WalmartPage';
import NoonPage from './pages/services/NoonPage';
import EbayPage from './pages/services/EbayPage';
import AliExpressPage from './pages/services/AliExpressPage';
import FlipkartPage from './pages/services/FlipkartPage';
import MeeshoPage from './pages/services/MeeshoPage';
import MyntraPage from './pages/services/MyntraPage';
import NykaaPage from './pages/services/NykaaPage';
import AjioPage from './pages/services/AjioPage';
import BlinkitPage from './pages/services/BlinkitPage';
import PerformanceMarketingPage from './pages/services/PerformanceMarketingPage';
import WebDevelopmentPage from './pages/services/WebDevelopmentPage';

function HomePage() {
  return (
    <>
      <div className="hero-wrapper">
        <div className="blob blob-blue1" />
        <div className="blob blob-blue2" />
        <div className="blob blob-cyan" />

        <Header />

        <section id="home"><HeroSection /></section>
        <BrandsStrip />
        <section id="about"><AboutSection /></section>
        <section id="services"><MarketplaceSection /></section>
        <section id="work"><YouTubeSection /></section>
        <section id="blog"><BlogSection /></section>
        <section id="faq"><FaqSection /></section>

        <ChatBot />
        <PopupForm />
      </div>
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageLoader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogDetailPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/admin" element={<AdminDashboard />} />

        {/* Marketplace service pages */}
        <Route path="/services/amazon" element={<AmazonPage />} />
        <Route path="/services/shopify" element={<ShopifyPage />} />
        <Route path="/services/walmart" element={<WalmartPage />} />
        <Route path="/services/noon" element={<NoonPage />} />
        <Route path="/services/ebay" element={<EbayPage />} />
        <Route path="/services/aliexpress" element={<AliExpressPage />} />
        <Route path="/services/flipkart" element={<FlipkartPage />} />
        <Route path="/services/meesho" element={<MeeshoPage />} />
        <Route path="/services/myntra" element={<MyntraPage />} />
        <Route path="/services/nykaa" element={<NykaaPage />} />
        <Route path="/services/ajio" element={<AjioPage />} />
        <Route path="/services/blinkit" element={<BlinkitPage />} />
        <Route path="/services/performance-marketing" element={<PerformanceMarketingPage />} />
        <Route path="/services/web-development" element={<WebDevelopmentPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
